// eslint-disable-next-line import/no-anonymous-default-export
export default {
  CONFIG: {
    SUGGESTION_CHAR_LIMIT: 5,
    MOLECULES: {
      MAP: {
        VIEW: {
          NORTH: 49.234,
          SOUTH: 24.175,
          EAST: -65.573,
          WEST: -125.778,
          ZOOM: 3
        },
        POSITION: {
          LATITUDE: 42.536457,
          LONGITUDE: -70.985786,
        }
      },
      MESSAGES: {
        ADDRESS_ERROR: 'Please enter a valid address'
      }
    }
  }
}